import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Headline4 from './Typography/Heading/Headline4';
import Headline6 from './Typography/Heading/Headline6';
import { GridCell } from './Grid';

const SuccessMessage = styled(GridCell)`
  && {
    padding: 32px;
  }
`;

const SuccessHeadline = styled(Headline4)`
  && {
    margin: 0 0 32px;
  }
`;

const SuccessSubHeadline = styled(Headline6)`
  && {
    padding: 0;
    margin: 12px 0;
  }
`;

const FormSubmitConfirmation = ({
  successHeadline,
  successMessage,
  redirectMessage,
}) => (
  <SuccessMessage>
    <SuccessHeadline>
      {successHeadline}
    </SuccessHeadline>
    <SuccessSubHeadline>
      {successMessage}
    </SuccessSubHeadline>
    <SuccessSubHeadline>
      {redirectMessage}
    </SuccessSubHeadline>
  </SuccessMessage>
);

FormSubmitConfirmation.propTypes = {
  successHeadline: PropTypes.string.isRequired,
  successMessage: PropTypes.string.isRequired,
  redirectMessage: PropTypes.string,
};

FormSubmitConfirmation.defaultProps = {
  redirectMessage: undefined,
};

export default FormSubmitConfirmation;
